import * as React from "react"
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group"

import { cn } from "../utils/cn"

const TabGroup = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>
>(({ className, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Root
      className={cn("inline-flex w-full items-start justify-start gap-8 border-b border-[#cdd7e1] bg-white", className)}
      {...props}
      ref={ref}
    />
  )
})
TabGroup.displayName = "TabGroup"

const TabItem = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item> & {
    thumbnail?: string
  }
>(({ className, children, thumbnail, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Item
      ref={ref}
      className={cn(
        "relative flex flex-1 items-center justify-between gap-2 px-2 pb-3 pt-2",
        "text-[15px] font-bold uppercase leading-[26px] tracking-[0.46px]",
        "cursor-pointer text-[#9fa6ad] transition-colors",
        "data-[state=checked]:text-[#32383e]",
        "data-[state=checked]:after:absolute data-[state=checked]:after:bottom-0 data-[state=checked]:after:left-0 data-[state=checked]:after:right-0",
        "data-[state=checked]:after:h-1 data-[state=checked]:after:bg-[#16a34a]",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#16a34a] focus-visible:ring-offset-2",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    >
      <span style={{ maxHeight: 52, overflow: "hidden", display: "block" }}>{children}</span>
      {thumbnail && (
        <div className="relative size-16 shrink-0">
          <img
            src={thumbnail}
            alt=""
            className="pointer-events-none absolute inset-0 size-full max-w-none object-contain object-center"
          />
        </div>
      )}
    </RadioGroupPrimitive.Item>
  )
})
TabItem.displayName = "TabItem"

export { TabGroup, TabItem }
